import { createContext, useContext } from "react";
import { createPortal } from "react-dom";
export const AppShellContext = createContext(null);
export const useAppShell = () => {
    const context = useContext(AppShellContext);
    if (!context) {
        throw new Error("useAppShell must be used inside DashboardLayout");
    }
    return context;
};
export const useOptionalAppShell = () => useContext(AppShellContext);
export const AppShellHeader = ({ children }) => {
    const { headerSlot } = useAppShell();
    if (!headerSlot)
        return null;
    return createPortal(children, headerSlot);
};
